var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRayLeftBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 81,
    viewBox: "0 0 300 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.333 8.15087C39.8327 -10.7933 -24.1672 8.14823 -8.66726 16.1517V95.1547H296.333C325.999 68.8203 357.533 43.2488 286.333 53.6512C197.333 66.6542 167.332 20.7802 116.333 8.15087Z",
    fill: "url(#paint0_linear_39122_21922)",
    fillOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_39122_21922",
    x1: 163.489,
    y1: 95.1487,
    x2: 163.489,
    y2: -9.0625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRayLeftBg);
export default __webpack_public_path__ + "static/media/ray-left-bg.40b4f11b669db4684983a917c9ac5494.svg";
export { ForwardRef as ReactComponent };